"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checks (big)number's in range
 */


var BigNumberRangeValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(BigNumberRangeValidator, _Validator_1$Validato);

  function BigNumberRangeValidator(min, max) {
    var _this;

    _classCallCheck(this, BigNumberRangeValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BigNumberRangeValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.min = min;
    _this.max = max;
    return _this;
  }

  _createClass(BigNumberRangeValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (this.min !== null && value.lt(this.min)) {
        return new ValidationResult_1.ValidationError(BigNumberRangeValidator.UNDER_MIN_VALUE_ERROR, this.min.toString());
      }

      if (this.max !== null && value.gt(this.max)) {
        return new ValidationResult_1.ValidationError(BigNumberRangeValidator.OVER_MAX_VALUE_ERROR, this.max.toString());
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return BigNumberRangeValidator;
}(Validator_1.Validator);

exports.BigNumberRangeValidator = BigNumberRangeValidator;
BigNumberRangeValidator.UNDER_MIN_VALUE_ERROR = 'UNDER_MIN_VALUE';
BigNumberRangeValidator.OVER_MAX_VALUE_ERROR = 'OVER_MAX_VALUE';